"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedNetworks = void 0;
const networks_1 = __importDefault(require("./networks"));
/**
 * Retrieves the list of supported networks. If a network type is provided, the
 * function returns networks that support the specific functionality. If no type
 * is provided, it returns all networks.
 *
 * @param {NetworkType} [type] - Optional argument to return only networks that
 * support specific functionality. Accepts "ccm".
 *
 * @returns {string[]} An array of strings representing the supported networks.
 */
const getSupportedNetworks = (type) => {
    let supportedNetworks = Object.keys(networks_1.default);
    if (type === "ccm") {
        const excluded = [
            "btc_testnet",
            "zeta_testnet",
            "baobab_testnet",
            "eth_mainnet", // TODO: remove when eth_mainnet is supported
        ];
        supportedNetworks = supportedNetworks.filter((network) => !excluded.includes(network));
    }
    return supportedNetworks;
};
exports.getSupportedNetworks = getSupportedNetworks;
